import classNames from "classnames"
import { BorderShape } from "components/DesignSystem"

import { ControlStateOptions } from "./ControlStateOptions"
import { determineBorderClass } from "./determineBorderClass"
import { determinePseudoClass } from "./determinePseudoClass"

/**
 * A function that determines the border class based on the passed
 * state options and shape.
 */
export function determineControlBorderClass(state: ControlStateOptions, shape: BorderShape = "border/shape/6") {
  // readonly controls don't have a border at all.
  if (state.readOnly) {
    return "border-none"
  }

  if (state.active) {
    return determineBorderClass("border/primary", shape)
  }

  if (state.error) {
    return classNames(
      determineBorderClass("border/error", shape),
      determinePseudoClass(determineBorderClass("border/error", shape), "focus")
    )
  }

  if (state.success) {
    return classNames(
      determineBorderClass("border/success", shape),
      determinePseudoClass(determineBorderClass("border/success", shape), "focus")
    )
  }

  if (state.disabled) {
    return determineBorderClass("border/secondary", shape)
  }

  return classNames(
    // We also have border/default, but we want to use border/secondary as this is
    // how it's in the Design System. The border/default is used for cards components
    // and secondary is used for controls.
    determineBorderClass("border/secondary", shape),
    determinePseudoClass(determineBorderClass("border/primary", shape), "focus")
  )
}
